import type { OnIntersectFn } from '@shared/utils/hooks/useOnIntersectingChange';
import { useOnIntersectingChange } from '@shared/utils/hooks/useOnIntersectingChange';
import { Portal } from '@withjoy/joykit';
import React, { useCallback, useState } from 'react';
import type { CatalogItemTile } from '../../../../Catalog.types';
import { ProductQuickAddBar } from '../ProductQuickAddBar';
import type { AddCatalogItemArgs } from '../BuyForm/BuyForm.types';

export interface StickyProductQuickAddBar {
  isAddingItem: boolean;
  isMobile?: boolean;
  handleAddCatalogItem: (args?: AddCatalogItemArgs) => void;
  selectedProduct: Maybe<CatalogItemTile>;
  selectedImage?: string;
  showSkeleton?: boolean;
  intersectionRef: React.RefObject<HTMLDivElement>;
}

export const StickyProductQuickAddBar: React.FC<StickyProductQuickAddBar> = props => {
  const { isAddingItem, isMobile, selectedProduct, selectedImage, showSkeleton, handleAddCatalogItem, intersectionRef } = props;
  const [buyFormIsOnScreen, setBuyFormIsOnScreen] = useState(true);

  const onIntersectingTriggerPointEl = useCallback<OnIntersectFn>((isIntersecting, entry) => {
    setBuyFormIsOnScreen(isIntersecting);
  }, []);

  useOnIntersectingChange(intersectionRef, onIntersectingTriggerPointEl, {
    threshold: 0,
    rootMargin: isMobile ? '-110px 0px 0px 0px' : '0px',
  });

  return (
    <Portal>
      <ProductQuickAddBar
        display={buyFormIsOnScreen ? 'none' : 'flex'}
        brand={selectedProduct?.brand?.name}
        name={selectedProduct?.title}
        priceFloatingPointDecimalString={selectedProduct?.price?.floatingPointDecimalString}
        priceCurrencyCode={selectedProduct?.price?.currency?.code}
        storefrontInfo={selectedProduct?.storefrontInfo}
        isMobile={isMobile}
        isAddingItem={isAddingItem}
        photoUrl={selectedImage}
        onAddCatalogItem={handleAddCatalogItem}
        showSkeleton={showSkeleton}
        backgroundColor={'white'}
        zIndex={11}
        position={'fixed'}
        right={0}
        top={!isMobile ? 0 : null}
        bottom={isMobile ? 0 : null}
      ></ProductQuickAddBar>
    </Portal>
  );
};
